export default __webpack_public_path__ + "static/media/news-stream-logo.d23a5588.svg";